// صفحة مهام بنين - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const BaneenTasks = () => (
  <EmployeeTasksPage employeeName="بنين" title="بنين" backPath="/Baneen" />
);

export default BaneenTasks;
